import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-currency-dollar-icon',
  templateUrl: 'currency-dollar-icon.component.html'
})
export class CurrencyDollarIconComponent {
  constructor() {}
}
